import React, { useContext } from 'react'
import { Flex, Heading, Link, Text as ChakraText } from '@chakra-ui/layout'
import { Button } from '@chakra-ui/react'
import { NavLink, useRouteMatch } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import { colors } from '../../../ui-kit'
import ExternalStorageHomeGraphic from '../../../graphics/ExternalStorageHomeGraphic'
import PermissionGuard from '../../components/PermissionGuard'
import { PermissionsEnum } from '../../../utils'

const HomeLayout = (): React.ReactElement => {
  const { path } = useRouteMatch()
  const { t } = useTranslation()

  return (
    <PermissionGuard
      permission={PermissionsEnum.SELF_INTEGRATION_MANAGE}
    >
      {
        (hasPermission: boolean) => (
          <Flex
            flexDirection="column"
            textAlign="center"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            width="100%"
            p={10}
          >
            <ExternalStorageHomeGraphic h={56} w={56} />
            <Heading as="h6" size="md" fontWeight="600" marginBottom="1em">
              {
                hasPermission ?
                t('create_a_new_origin') :
                t('external_storage')
              }
            </Heading>

            <ChakraText
              color={colors.appBattleshipGrey}
              fontWeight="500"
              fontSize="1em"
              maxW={96}
              margin="0 auto"
            >
              {t('external_storage_info')}
              <br />
              <Trans t={t} i18nKey="learn_more_from_the_docs">
                <Link
                  fontSize="1em"
                  isExternal
                  href="https://docs.imagekit.io/integration/integration-overview"
                >
                  Learn more
                </Link>{' '}
                from the docs.
              </Trans>
            </ChakraText>
            {
              hasPermission ? (
                <Link
                  as={NavLink}
                  position="relative"
                  display="flex"
                  alignItems="center"
                  to={`${path}/new`}
                  margin="0 auto"
                  marginTop="1em"
                  _hover={{ textDecoration: 'none', outline: 'none' }}
                >
                  <Button>+{t('add_new')}</Button>
                </Link>
              ) : null
            }
          </Flex>
        )
      }
    </PermissionGuard>
  )
}

export default HomeLayout
